import React, { Component } from 'react';
import { connect } from 'react-redux';
import MessageCom from "layouts/Dashboard/Message";


class LoginPage extends Component{
	constructor(props){
		super(props);
    this.state = {
            username    : '',
            submitted   : false
        };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
	};
  handleChange(e) {
      const { name, value } = e.target;
      this.setState({ [name]: value });
  }

  handleSubmit(e) {
      e.preventDefault();

      this.setState({ submitted: true });
      const { username } = this.state;
      // const { dispatch } = this.props;

      if (username) {

          //dispatch(adminUserActions.login(username, password));
      }
  }
  render(){
    const { username, submitted } = this.state;
    const { loggingIn } = this.props;
  	return(
    	<div className="main_login">
          
          <div className="login_form_container">
              <div className="login_form">
                  <h1 className="text-center testrrr"  >Music Director Login</h1>
                  <form name="form" onSubmit={this.handleSubmit}>
                      <div className={'form-group' + (submitted && !username ? ' has-error' : '')}>
                          <input type="text" placeholder="Enter Your Username..." className="form-control username_ctrl" name="username" value={username} onChange={this.handleChange} />
                          {submitted && !username &&
                              <div className="help-block">Username is required.</div>
                          }
                      </div>
                      <div className="form-group">
                          <button className="btn btn-default btn_login">LOGIN</button>
                          {
                              loggingIn &&
                              <img alt="imageLogin" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                          }
                      </div>                        
                  </form>
              </div>
              <MessageCom  />
          </div>
      </div>
  	);
   }
}

function mapStateToProps(state) {
    const { loading, musicDirector, loggedIn } = state.musicDirectorReducer;
    return {
        loading, musicDirector, loggedIn
    };
}

const Login = connect(mapStateToProps)(LoginPage);
export default Login;


// WEBPACK FOOTER //
// ./src/components/FrontEnd/Login.jsx